import { useState,useEffect } from "react";
import { Box, TextField, Button, MenuItem, Typography, Grid } from "@mui/material";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import WatchLaterIcon from "@mui/icons-material/WatchLater";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import BadgeIcon from "@mui/icons-material/Badge";

import CarRentalSteps from "../Components/FillerComponents/taxione";
import DiscountInfo from "../Components/FillerComponents/taxitwo";



const BookingSection = ({ backgroundImage }) => {
  const [formData, setFormData] = useState({
    name: "",
    carType: "",
    pickupLocation: "",
    phone: "",
  });

  const travelOwnerNumber = "6230206562"; // Replace with actual WhatsApp number


  useEffect(() => {
      window.scrollTo(0, 0); // Scrolls to the top when component mounts
    }, []);
  
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = () => {
    const { name, carType, pickupLocation, phone } = formData;

    if (!name || !carType || !pickupLocation || !phone) {
      alert("Please fill all fields");
      return;
    }

    const message = `Booking Request:
    - Name: ${name}
    - Car: ${carType}
    - Pickup Location: ${pickupLocation}
    - Phone: ${phone}`;

    const whatsappURL = `https://wa.me/${travelOwnerNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <Box>
      {/* Background Image + Form Section */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          minHeight: "450px",
          backgroundImage: `url(${backgroundImage})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "0px",
          "&:before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay effect
            zIndex: 1,
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            backgroundColor: "rgba(255, 255, 255, 0.84)",
            padding: "30px",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
            width: "100%",
            maxWidth: "650px",
            textAlign: "center",
            zIndex: 2,
          }}
        >
          <Typography variant="h5" fontWeight="bold" gutterBottom>
            Book Your Ride
          </Typography>
          <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
            <TextField
              fullWidth
              select
              label="Select Car"
              name="carType"
              variant="outlined"
              value={formData.carType}
              onChange={handleChange}
            >
              <MenuItem value="Sedan">Sedan (2-4 Seater)</MenuItem>
              <MenuItem value="SUV">SUV (6-8 Seater)</MenuItem>
              <MenuItem value="Luxury">Luxury Car</MenuItem>
            </TextField>
            <TextField
              fullWidth
              label="Pick Up Location"
              name="pickupLocation"
              variant="outlined"
              onChange={handleChange}
            />
          </Box>
          <Box sx={{ display: "flex", gap: 2 }}>
            <TextField
              fullWidth
              label="Your Name"
              name="name"
              variant="outlined"
              onChange={handleChange}
            />
            <TextField
              fullWidth
              label="Phone Number"
              name="phone"
              type="tel"
              variant="outlined"
              onChange={handleChange}
            />
          </Box>
          <Button
            fullWidth
            variant="contained"
            sx={{
              backgroundColor: "#FFC107",
              color: "#000",
              marginTop: "20px",
              fontSize: "18px",
              fontWeight: "bold",
              padding: "10px",
              borderRadius: "30px",
              "&:hover": { backgroundColor: "#FFA000" },
            }}
            onClick={handleSubmit}
          >
            BOOK NOW
          </Button>
        </Box>
      </Box>

      {/* Features Section */}
      <Box sx={{ backgroundColor: "#F8F9FA", padding: "40px 20px" }}>
        <Grid container spacing={3} justifyContent="center">
          {features.map((feature, index) => (
            <Grid item xs={12} sm={6} md={3} key={index}>
              <Box
                sx={{
                  backgroundColor: "#fff",
                  padding: "20px",
                  borderRadius: "10px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                  textAlign: "center",
                }}
              >
                <Box
                  sx={{
                    width: "50px",
                    height: "50px",
                    backgroundColor: "#FFC107",
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "auto",
                    marginBottom: "10px",
                  }}
                >
                  {feature.icon}
                </Box>
                <Typography variant="h6" fontWeight="bold">
                  {feature.title}
                </Typography>
                <Typography variant="body2" color="textSecondary">
                  {feature.description}
                </Typography>
              </Box>
            </Grid>
          ))}
        </Grid>
      </Box>
      <CarRentalSteps/>
     <DiscountInfo/>
     
    </Box>
  );
};

// Feature Cards Data
const features = [
  {
    title: "24 Hours Support",
    description: "Our travel experts are available 24/7. Book cab in Shimla & Manali with us.",
    icon: <WatchLaterIcon fontSize="large" />,
  },
  {
    title: "Well Maintained Cars",
    description: "We have a fleet of well-maintained vehicles for Shimla & Manali trips.",
    icon: <DirectionsCarIcon fontSize="large" />,
  },
  {
    title: "Quality Assurance",
    description: "We assure you of great taxi service with a memorable experience.",
    icon: <CheckCircleIcon fontSize="large" />,
  },
  {
    title: "Experienced Drivers",
    description: "Our drivers are acquainted with Shimla & Manali routes and are highly experienced.",
    icon: <BadgeIcon fontSize="large" />,
  },
];

export default BookingSection;
